<template>
  <article class="view-invoice-page">
    <div class="heading">
      <AppLogo class="heading-logo"></AppLogo>

      <div class="heading-text-group">
        <h1 class="heading-title">Mộc Châu Island</h1>
        <div class="heading-caption">Mường Sang - Mộc Châu - Sơn La</div>
        <div class="heading-caption-group">
          <div class="heading-caption">Tel: 1900 2829</div>
          <div class="divider vertical"></div>
          <div class="heading-caption">Fax: 0212 3768 768</div>
        </div>
        <div class="heading-caption-group">
          <div class="heading-caption">Email: info@mocchauisland.com</div>
          <div class="divider vertical"></div>
          <div class="heading-caption">Website: mocchauisland.com</div>
        </div>
      </div>
    </div>
    <div class="hr"></div>
    <div class="title-form">
      <h1 class="heading-title">Hóa đơn tạm tính</h1>
      <p class="provisional-note">Chưa phải hóa đơn thanh toán</p>
      <p class="heading-caption">
        Thời gian in: {{ $moment().format('HH:mm DD/MM/YYYY') }}
      </p>
    </div>
    <div class="invoice-info-item" style="margin-bottom: 10px">
      <span class="item-label">Công ty: </span
      >{{ (customerInfo.company || info.agent_name) ?? '' }}
    </div>

    <div class="section-invoice-info">
      <div>
        <div class="invoice-info-item">
          <span class="item-label">Tên khách: </span
          >{{ (customerInfo.name || info.customer_name) ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Số điện thoại: </span
          >{{ (customerInfo.phone_number || info.phone_number) ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Ngày nhận phòng: </span
          >{{ (customerInfo.from || info.arrive_date) ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Ngày trả phòng: </span
          >{{ (customerInfo.to || info.depart_date) ?? '' }}
        </div>
      </div>
      <div class="section-invoice-info-right">
        <div class="invoice-info-item">
          <span class="item-label">Loại tiền:</span> VND
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Người in: </span
          >{{ printer?.full_name ?? '' }}
        </div>
        <div
          class="invoice-info-item"
          style="font-weight: 600; font-size: 16pt; margin-top: 15px"
        >
          {{ recodeGroup }}
        </div>
      </div>
    </div>
    <div class="hr"></div>
    <div>
      <table class="table-transaction">
        <thead>
          <tr>
            <th>STT</th>
            <th>Ngày</th>
            <th>Diễn giải</th>
            <th>Loại giao dịch</th>
            <th>Số phòng</th>
            <th class="text-right">Tổng</th>
          </tr>
        </thead>
        <tbody
          v-for="(transaction, index) in transactions"
          :key="transaction.roomTransactionId || index"
          class="transaction-group"
        >
          <tr>
            <td>{{ index + 1 }}</td>
            <td>{{ $moment(transaction.trans_date).format('DD/MM/YYYY') }}</td>
            <td>{{ transaction.sub_transaction_desc }}</td>
            <td>{{ transaction.room_transaction_type }}</td>
            <td>{{ transaction.room_num }}</td>
            <td class="text-right">
              {{ Intl.NumberFormat().format(transaction.money) }}
            </td>
          </tr>
          <tr
            v-for="(detail, detailIndex) in transaction.details || []"
            :key="detailIndex"
            class="transaction-detail"
          >
            <td></td>
            <td colspan="4" class="detail-description">
              {{ detail.name }} ({{ detail.code }})
              <span class="detail-calculation">
                {{ Intl.NumberFormat().format(detail.quantity) }} ×
                {{ Intl.NumberFormat().format(detail.unit_price) }}
              </span>
            </td>
            <td class="text-right">
              {{ Intl.NumberFormat().format(detail.total) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="hr"></div>
    <div style="display: flex">
      <table class="section-summary" style="margin-right: auto; margin-left: 0">
        <tbody>
          <tr>
            <td style="font-size: 12pt">Hình thức thanh toán</td>
            <td></td>
          </tr>
          <tr
            v-for="payment in Object.values(payments).filter(
              item => item.amount > 0
            )"
            :key="payment.name"
          >
            <td>{{ payment.name }}</td>
            <td class="text-right">
              {{ Intl.NumberFormat().format(payment.amount) }}
            </td>
          </tr>
          <tr
            v-for="payment in Object.values(payments).filter(
              item => item.amount == 0
            )"
            :key="payment.name"
          >
            <td></td>
            <td class="text-right"></td>
          </tr>
        </tbody>
      </table>
      <table class="section-summary">
        <tbody>
          <tr>
            <td style="font-size: 12pt">Thành tiền</td>
            <td>{{ Intl.NumberFormat().format(summary.money) }}</td>
          </tr>
          <tr>
            <td>Đã đặt cọc</td>
            <td>{{ Intl.NumberFormat().format(summary.deposit) }}</td>
          </tr>
          <tr>
            <td>Số phải thanh toán</td>
            <td>{{ Intl.NumberFormat().format(summary.payment) }}</td>
          </tr>
          <tr>
            <td>Tổng đã thanh toán</td>
            <td>{{ Intl.NumberFormat().format(summary.paid) }}</td>
          </tr>
          <tr>
            <td>Còn phải trả</td>
            <td>{{ Intl.NumberFormat().format(summary.unpaid) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="hr"></div>
    <!-- <div>
      <table class="table-payments">
        <thead>
          <tr>
            <th>Diễn giải</th>
            <th>Loại thanh toán</th>
            <th>Loại tiền</th>
            <th class="text-right">Số tiền</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="payment in Object.values(payments)" :key="payment.name">
            <td></td>
            <td>{{ payment.name }}</td>
            <td>VND</td>
            <td class="text-right">
              {{ Intl.NumberFormat().format(payment.amount) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div> -->

    <div class="section-signature">
      <div>
        <span>Chữ ký thu ngân</span>
      </div>
      <div>
        <span>Chữ ký khách hàng</span>
      </div>
    </div>
  </article>
</template>
<script>
import { getProvisionalInvoice } from '@/api/cashier_service/room-transaction'
import { getUserDetailApi } from '@/api/profile/profile'
import AppLogo from '@/components/AppLogo.vue'
// import InfoList from '@/components/info-list/InfoList.vue'
// import InfoListInput from '@/components/info-list/InfoListInput.vue'
// import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
export default {
  components: {
    AppLogo
  },

  data() {
    return {
      isView: false,
      printMessageSent: false,
      recodeGroup: null,
      subBookingId: null,
      printer: null,
      customerInfo: {
        company: null,
        name: null,
        phone_number: null,
        from: null,
        to: null
      },
      summary: {
        money: 0,
        deposit: 0,
        payment: 0,
        paid: 0,
        unpaid: 0
      },
      payments: {
        cash: {
          name: 'Tiền mặt',
          amount: null
        },
        card: {
          name: 'Thẻ',
          amount: null
        },
        bank_transfer: {
          name: 'Chuyển khoản',
          amount: null
        },
        foc: {
          name: 'Miễn phí',
          amount: null
        },
        debt: {
          name: 'Công nợ',
          amount: null
        }
      },
      transactions: [],
      info: {
        agent_name: null,
        customer_name: null,
        address: null,
        arrive_date: null,
        depart_date: null
      }
    }
  },
  created() {},
  async mounted() {
    this.subBookingId = this.$route.query.id
    this.recodeGroup = this.$route.query.recode
    this.customerInfo.name = this.$route.query.name
    this.customerInfo.company = this.$route.query.company
    this.customerInfo.from = this.$route.query.from
    this.customerInfo.to = this.$route.query.to
    this.customerInfo.phone_number = this.$route.query.phone
    if (this.$route.query.isView) {
      this.isView = true
    }
    try {
      const res = await getProvisionalInvoice({
        subBookingGroupId: this.subBookingId,
        recodeGroup: this.recodeGroup,
        byDay: false,
        byTransaction: false
      })
      this.transactions = res.data.data
      Object.keys(this.payments).forEach(key => {
        this.payments[key].amount = res.data[key]
      })
      Object.keys(this.summary).forEach(key => {
        this.summary[key] = res.data[key]
      })
      Object.keys(this.info).forEach(key => {
        this.info[key] = res.data[key]
      })
      const userRes = await getUserDetailApi()
      this.printer = userRes.data.user
    } catch (error) {
      if (!this.isView) {
        this.notifyParent('provisional-invoice/error', error.response?.data?.message || error.message)
      }
      return
    }

    if (!this.isView) {
      this.$nextTick(() => {
        window.addEventListener('afterprint', this.handleAfterPrint)
        try {
          window.print()
          this.handleAfterPrint()
        } catch (error) {
          this.notifyParent('provisional-invoice/error', error.message)
        }
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('afterprint', this.handleAfterPrint)
  },
  methods: {
    handleAfterPrint() {
      this.notifyParent('provisional-invoice/done')
    },
    notifyParent(type, message) {
      if (this.printMessageSent) return
      this.printMessageSent = true
      window.removeEventListener('afterprint', this.handleAfterPrint)
      window.parent.postMessage({ type, ...(message ? { message } : {}) }, window.location.origin)
    }
  }
}
</script>
<style>
@media print {
  * {
    overflow: visible !important;
  }
  .view-invoice-page {
    max-width: unset;
  }
}
</style>
<style scoped>
.provisional-note {
  margin: 0 0 8pt;
  text-align: center;
  font-size: 9pt;
  font-style: italic;
}
.transaction-group,
.transaction-detail {
  page-break-inside: avoid;
  break-inside: avoid;
}
.transaction-detail td {
  font-size: 9pt;
  color: #555;
}
.transaction-detail .detail-description {
  padding-left: 10pt !important;
}
.detail-calculation {
  margin-left: 10pt;
  white-space: nowrap;
}
.view-invoice-page {
  max-width: 200mm;
  margin: 0 auto;
}
body {
  overflow: hidden !important; /* Hide scrollbars */
}
table,
td,
th,
tr,
thead {
  border: none !important;
}
* {
  font-size: 10pt;
}
thead th {
  font-weight: 500;
}

table td,
table th {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.section-invoice-info {
  display: grid;
  grid-template-columns: 75% 25%;
}
.section-invoice-info-right {
  text-align: right;
}
.invoice-info-item {
  display: block;
  margin-top: 0.5rem;
}

.invoice-info-item .item-label {
  font-weight: 600;
}

.invoice-info-item:first-child {
  margin-top: 0;
}
.section-signature {
  page-break-inside: avoid;
  min-height: 80pt;
  margin-top: 40pt;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.hr {
  margin-top: 16pt;
  margin-bottom: 16pt;
  border-top: 0.5pt solid #e5e7eb !important;
}
.section-summary td {
  border: none;
  padding-top: 0 !important;
}

.section-summary tr:last-child td {
  padding-bottom: 0 !important;
}

.section-summary {
  width: fit-content;
  margin-left: auto;
}
.section-summary-right {
  margin-right: auto;
}
table td.text-right,
table th.text-right {
  text-align: right;
}
table th {
  color: black;
  text-align: left;
  border: none;
}
table thead {
  background-color: unset;
}

table td:last-child {
  padding-right: 0 !important;
}
.title-form {
  .heading-title {
    text-align: center;
  }
  .heading-caption {
    text-align: center;
    color: black;
    font-size: 10pt;
    font-style: italic;
  }
}
.section-summary td:first-child {
  font-weight: 500;
  font-size: 10pt;
  text-align: left;
}

.section-summary td:last-child {
  text-align: right;
  padding-left: 20pt !important;
}
.section-summary td {
  height: 25px;
}

.divider.vertical {
  height: 10pt;
  flex-shrink: 0;
  width: 0;
  border-left: 1px solid rgb(156 163 175);
}

.heading-title {
  margin: 0;
  margin-bottom: 8pt;
  font-size: 20pt;
  font-weight: 600px;
  text-transform: uppercase;
}
.heading-caption-group {
  display: flex;
  margin-top: 4pt;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 6pt;
}
.heading-caption {
  color: rgb(156 163 175);
}
.heading-text-group {
  text-align: center;
  height: fit-content;
}
.heading {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.heading-logo {
  height: 120pt;
  width: auto;
}

.table-payments,
.table-transactions {
  border-collapse: collapse;
}
.table-payments td,
.table-transactions td,
.table-payments th,
.table-transactions th {
  border: 1px solid black !important;
  padding: 6pt !important;
}
.table-transactions .text-right,
.table-payments .text-right {
  text-align: right;
}
.table-transactions td:last-child,
.table-payments td:last-child {
  padding-right: 6pt !important;
}
</style>
